// Lightweight Plausible wrapper. No-ops gracefully if the script hasn't loaded
// (e.g. ad-blockers, local dev) so callers never have to guard.
type PlausibleProps = Record<string, string | number | boolean>;

declare global {
  interface Window {
    plausible?: (event: string, options?: { props?: PlausibleProps }) => void;
  }
}

export function trackEvent(eventName: string, props?: PlausibleProps): void {
  try {
    if (typeof window === "undefined") return;
    if (typeof window.plausible === "function") {
      window.plausible(eventName, props ? { props } : undefined);
    }
  } catch (err) {
    // Never let analytics break the UI
    console.warn("Analytics error:", err);
  }
}
